import { validateStepsByValidationResults } from 'sos-eservice-common/js/Redux/Reducers/validation.helpers';
import { StatisticsOrderProps } from './StatisticsOrder.types';
import { statisticsOrderGlobals } from '../../models';
import { countryList } from './steps/dhsCountries';

export function getInitialState(props: StatisticsOrderProps) {
  const {
    model,
    orderId,
    translations,
    internalRegistriescauseOfDeath,
    internalRegistrieshealthData,
    internalRegistriessocialServices,
    files,
    validationResults,
    homePageUrl,
    thankYouPageUrl,
  } = props;

  const registers = {
    internalRegistriescauseOfDeath,
    internalRegistrieshealthData,
    internalRegistriessocialServices
  };
  const globals = {
    currentStep: 1,
    hasHitSummary: false,
    homePageUrl,
    orderId,
    shouldShowDelete: !!orderId,
    thankYouPageUrl,
    translations,
    isSending: false
  } as Partial<statisticsOrderGlobals>;

  const initialValidationState = {
    stepValidationMap: {
      0: {
        isValid: false,
        stepId: 0
      },
      1: {
        isValid: false,
        stepId: 1
      }
    },
    validationResults,
    fullValidationResults: validationResults,
    touchedFields: []
  };

  const validationState = validateStepsByValidationResults(
    initialValidationState
  );

  return {
    files,
    formModel: model,
    globals,
    registers,
    validationState
  };
}
